module.exports = __webpack_public_path__ + "img/product_xd_ng_2.1732fa4e.jpg";